import * as go from 'gojs';

export const setPropertyOnPredecessors = (
  entry: go.Node | go.Link | go.Group,
  propertyName: string,
  propertyValue: unknown,
) => {
  if (!entry) {
    return;
  }

  if (entry instanceof go.Group) {
    entry.diagram?.model.set(entry.data, propertyName, propertyValue);
    return;
  }

  let node: go.Node | null;
  if (entry instanceof go.Link) {
    node = entry.toNode || entry.fromNode;
  } else if (entry instanceof go.Node) {
    node = entry;
  } else {
    throw new Error('Invalid Entry Object');
  }

  if (!node) {
    return;
  }

  const diagram = node.diagram;
  const stack: go.Set<go.Node> = new go.Set([node]);
  const it = stack.iterator;
  const used = new Set<go.Key>();

  while (it.next()) {
    const currentNode = it.value;

    if (!currentNode || used.has(currentNode.key)) {
      continue;
    }
    used.add(currentNode.key);

    diagram?.model.set(currentNode.data, propertyName, propertyValue);

    if (
      currentNode.key !== node.key &&
      currentNode.containingGroup &&
      !currentNode.containingGroup.isSubGraphExpanded
    ) {
      diagram?.model.set(currentNode.containingGroup.data, propertyName, propertyValue);
    }

    currentNode.findLinksInto().each((l: go.Link) => diagram?.model.set(l.data, propertyName, propertyValue));
    stack.addAll(currentNode.findNodesInto());
  }
};

export const setPropertyOnNode = (entry: go.Node | go.Group, propertyName: string, propertyValue: unknown) => {
  const diagram = entry.diagram;
  diagram?.model.set(entry.data, propertyName, propertyValue);
};
